import {Component, EventEmitter, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {HttpStatusCode} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {CustomMessageService, LocalStorageService, ResponseHttpError, ResponseHttpSuccess} from 'library';
import {EnrollmentStatus, LocalStorageKey, SalesWorkflowSteps} from 'projects/store/src/app/enums';
import {RequestService} from 'projects/store/src/app/services/api/v1/request.service';
import {finalize} from 'rxjs';

@Component({
  selector: 'app-sales-phone-register-engine',
  templateUrl: './sales-phone-register-engine.component.html',
})
export class SalesPhoneRegisterEngineComponent {
  form: FormGroup;
  requestId: string;
  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Registro teléfono'];
  visibleModalIMEI = false;
  visibleModalInstructions = false;
  submitted = false;
  loading = false;
  hasEnrollmentError = false;
  errorMessage!: string;

  @Output() nextStepEvent = new EventEmitter<void>();
  @Output() gotoStepEvent = new EventEmitter<string>();

  constructor(private route: ActivatedRoute,
              private customMessageService: CustomMessageService,
              private requestService: RequestService,
              private localStorageService: LocalStorageService) {
    this.form = new FormGroup({
      imei: new FormControl('', [Validators.required]),
    });
    this.requestId = this.route.snapshot.params['request_id'];
  }

  onIntroduceIMEI() {
    this.visibleModalIMEI = true;
  }

  onSearchIMEI() {
    this.visibleModalInstructions = true;
  }

  onProgressEnrollment() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }

    this.save();
  }

  private save() {
    this.loading = true;
    this.hasEnrollmentError = false;
    this.errorMessage = '';

    this.requestService.createEnrollmentEngine(this.requestId, this.form.value)
      .pipe(finalize(() => this.loading = false))
      .subscribe({
        next: (resp: ResponseHttpSuccess) => {
          if (resp.status === HttpStatusCode.Created || resp.status === HttpStatusCode.Ok) {
            const enrollmentId = resp.body.data.enrollment_id;
            this.localStorageService.set(LocalStorageKey.phoneEnrollmentFlowContext, {
              type: EnrollmentStatus.engine,
              enrollmentId
            });
            this.onNextStep();
          } else {
            this.customMessageService.responseNoticeHandler(resp);
          }
        },
        error: (error: ResponseHttpError) => {
          this.errorMessage = error.error?.message;
          this.form.get('imei')?.setErrors({serverError: true});
          this.hasEnrollmentError = true;
        }
      });
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  onHide() {
    this.visibleModalIMEI = false;
    this.visibleModalInstructions = false;
  }

  onGotoStep(stepCode: string) {
    this.gotoStepEvent.emit(stepCode);
  }

  get f() {
    return this.form.controls;
  }

  protected readonly SalesWorkflowSteps = SalesWorkflowSteps;
}
